import React, { useEffect, useRef } from "react";
import ViewHeadlineIcon from "@mui/icons-material/ViewHeadline";
import Logo from "../../images/logo.png";
import "../../../styles/Navbar.css";
import "./DApps.css";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
const Dapps = () => {
  const navbarRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    const navbarHeight = navbarRef.current.offsetHeight;
    contentRef.current.style.marginTop = navbarHeight + "px";
  }, []);
  return (
    <>
      <nav
        ref={navbarRef}
        className="navbar navbar-expand-lg fixed-top bg-secondary"
      >
        <div className="w-100 d-flex">
          <div className="w-50 d-flex align-items-center justify-content-start">
            <img
              src={Logo}
              className="Logo d-none d-sm-block"
              alt="Logo of Company"
            />
            <a className="navbar-brand text-white ms-0 ms-sm-4 fs-4" href="/">
              Phoenix Labs
            </a>
          </div>
          <div className="w-50 d-flex  align-items-center justify-content-end">
            <button
              className="navbar-toggler "
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon text-white">
                <ViewHeadlineIcon />
              </span>
            </button>
          </div>
        </div>
        <div className="navbar-collapse w-100" id="navbarSupportedContent">
          <ul className="navbar-nav d-flex justify-content-around align-items-center w-100">
            <li className="nav-item px-5 py-2 p-md-0 ">
              <a className="text-white" href="/cryptoTechnologyCenter/">
                Home
              </a>
            </li>
            <li className="nav-item px-5 py-2 p-md-0 ">
              <a className="text-white" href="/cryptoTechnologyCenter/events">
                Events & Webinars
              </a>
            </li>
            <li className="nav-item px-5 py-2 p-md-0 ">
              <a className="text-white" href="/membership">
                Membership
              </a>
            </li>

            <div className="dropdown px-5 py-2 p-md-0 ">
              <a
                className="dropdown text-white d-flex align-items-center"
                href="/"
                role="button"
                id="dropdownMenuLink"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Division <ArrowDropDownIcon />
              </a>
              <ul
                className="dropdown-menu mt-md-4"
                aria-labelledby="dropdownMenuLink"
              >
                <li>
                  <a
                    className="dropdown-item text-dark"
                    href="/cryptoTechnologyCenter/educationalHub"
                  >
                    Educational Hub
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item text-dark"
                    href="/cryptoTechnologyCenter/researchDevelopment"
                  >
                    Research & Development
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item text-dark"
                    href="/cryptoTechnologyCenter/Dapps"
                  >
                    DApp's Showcase
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item text-dark"
                    href="/cryptoTechnologyCenter/walletTechnologies"
                  >
                    Wallet Technologies
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item text-dark"
                    href="/cryptoTechnologyCenter/Dao"
                  >
                    DAO
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item text-dark"
                    href="/cryptoTechnologyCenter/cryptoProducts"
                  >
                    Crypto Products/Services
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item text-dark"
                    href="/cryptoTechnologyCenter/communityForum"
                  >
                    Community Forum
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item text-dark"
                    href="/cryptoTechnologyCenter/cryptotools"
                  >
                    Crypto Currency Tools
                  </a>
                </li>
              </ul>
            </div>
            <li className="nav-item px-5 py-2 p-md-0">
              <a className="text-white" href="/aboutus">
                About Us
              </a>
            </li>
          </ul>
        </div>
      </nav>

      <div ref={contentRef} className="DApps">
        <div className="Header">
          <section>
            <h1 className="Heading">
              Decentralized Applications (DApps) Showcase
            </h1>
          </section>
        </div>
        <div className="Content">
          <section className="card p-4 shadow-lg m-2">
            <h3> Display of Innovative DApps</h3>
            <p>
              Immerse yourself in our showcase of innovative decentralized
              applications. Witness firsthand how DApps are reshaping industries
              and creating new paradigms for user interaction and engagement.
            </p>
            <div className="Buttondiv">
              <a href="/cryptoTechnologyCenter/Dapps/Medichain">
                <button className="Dappsbutton">MediChain</button>
              </a>
              <a href="/cryptoTechnologyCenter/Dapps/caretoken">
                <button className="Dappsbutton"> CareToken </button>
              </a>
              <a href="/cryptoTechnologyCenter/Dapps/telehealthhub">
                <button className="Dappsbutton"> TeleHealthHub </button>
              </a>
              <a href="/cryptoTechnologyCenter/Dapps/pharmatrust">
                <button className="Dappsbutton">PharmaTrust </button>
              </a>
              <a href="/cryptoTechnologyCenter/Dapps/wellbeingdao">
                <button className="Dappsbutton">WellBeingDAO</button>
              </a>
            </div>
          </section>
          <section className="card p-4 shadow-lg m-2">
            <h3>Spotlight on DApps Developed Within the Community</h3>
            <p>
              Celebrate community-driven innovation as we spotlight DApps
              developed within the Phoenix Labs community. Explore the diversity
              and creativity of decentralized applications crafted by our
              talented members.
            </p>
          </section>
          <section className="card p-4 shadow-lg m-2">
            <h3>Opportunities for Collaboration and Investment</h3>
            <p>
              Forge connections and explore investment opportunities within our
              vibrant DApp ecosystem. Collaborate with developers and
              entrepreneurs who are pioneering the next wave of decentralized
              applications.
            </p>
          </section>
        </div>
      </div>
    </>
  );
};

export default Dapps;
